module.exports = __webpack_public_path__ + "static/DifficultyDifficultGames1-c4dd17668afeb60c124e175ac1acf33e.png";